var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggleMtLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2570_1390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 17.4951V19.0227L5.94534 18.768L14.6089 23.096L32.6579 10.1122L33.8611 13.931L40.5995 2.47455L29.7702 0L30.7327 4.34071L14.6089 16.0032L6.66732 11.9299L0 17.4951Z",
    fill: "#1177BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.6689H5.93672V40.2253H0V18.6689Z",
    fill: "#1177BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8125 18.8099L32.7492 14.6274V40.1293H26.8125V18.8099Z",
    fill: "#00C480"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3656 31.1186C19.18 31.1186 22.0283 30.304 22.0283 28.7474C22.0283 27.1905 19.18 26.376 16.3656 26.376C13.5514 26.376 10.7031 27.1905 10.7031 28.7474C10.7031 30.304 13.5514 31.1186 16.3656 31.1186Z",
    fill: "#1177BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7031 31.7507C10.7031 33.8264 13.5514 34.9123 16.3656 34.9123C19.18 34.9123 22.0283 33.8264 22.0283 31.7507V30.1699C22.0283 32.2455 19.18 33.3316 16.3656 33.3316C13.5514 33.3316 10.7031 32.2455 10.7031 30.1699V31.7507Z",
    fill: "#1177BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7031 34.5965C10.7031 36.6721 13.5514 37.7582 16.3656 37.7582C19.18 37.7582 22.0283 36.6721 22.0283 34.5965V33.0156C22.0283 35.0914 19.18 36.1773 16.3656 36.1773C13.5514 36.1773 10.7031 35.0914 10.7031 33.0156V34.5965Z",
    fill: "#1177BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7031 37.2837C10.7031 39.1518 13.5514 40.1292 16.3656 40.1292C19.18 40.1292 22.0283 39.1518 22.0283 37.2837V35.8608C22.0283 37.7289 19.18 38.7065 16.3656 38.7065C13.5514 38.7065 10.7031 37.7289 10.7031 35.8608V37.2837Z",
    fill: "#1177BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2570_1390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleMtLogo);
export default __webpack_public_path__ + "static/media/toggle-mt-logo.e336b0f14f83072d26f3f13b45525575.svg";
export { ForwardRef as ReactComponent };